import {
  GetConfigGradesResponse,
  UpdateGradesConfigRequest,
  UpdateGradesConfigResponse,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsGradesService = {
  async list(): Promise<GetConfigGradesResponse> {
    const response = await httpClient.get<GetConfigGradesResponse>(
      "v1/config/internal-grade/grades",
    );
    return response;
  },
  async update(
    body: UpdateGradesConfigRequest,
  ): Promise<UpdateGradesConfigResponse> {
    const response = await httpClient.patch<
      UpdateGradesConfigRequest,
      UpdateGradesConfigResponse
    >("v1/config/internal-grade/grades", body);
    return response;
  },
};

export default ConfigurationsGradesService;
